// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AnalyticsMonitorController from "./analytics_monitor_controller"
application.register("analytics-monitor", AnalyticsMonitorController)

import ChartTooltipController from "./chart_tooltip_controller"
application.register("chart-tooltip", ChartTooltipController)

import ClientSelectController from "./client_select_controller"
application.register("client-select", ClientSelectController)

import CtaClickController from "./cta_click_controller"
application.register("cta-click", CtaClickController)

import CurrencyLabelController from "./currency_label_controller"
application.register("currency-label", CurrencyLabelController)

import DeploymentMonitorController from "./deployment_monitor_controller"
application.register("deployment-monitor", DeploymentMonitorController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import HamburgerController from "./hamburger_controller"
application.register("hamburger", HamburgerController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import KeyboardController from "./keyboard_controller"
application.register("keyboard", KeyboardController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import TurnstileController from "./turnstile_controller"
application.register("turnstile", TurnstileController)
